import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const Navigation = () => {
	return (
		<Navbar expand="lg" className="bg-body-tertiary">
			<Container>
				<img src="./bilder/liten_katt_love.gif" alt="Katt som ger ut kärlek" />
				<Navbar.Brand href="./#">Allt om katter</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="me-auto">
						<Nav.Link href="./#">Hem</Nav.Link>
						<Nav.Link href="./#kattfakta">Kattfakta</Nav.Link>
						<Nav.Link href="./#faq">FAQ</Nav.Link>
						<Nav.Link href="./#kontakt">Kontakt</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};

export default Navigation;
